// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.authentrend",
    name: "AT.Wallet",
    homepage: "https://authentrend.com/at-wallet/",
    image_id: "98bd3b9a-097e-4743-8808-986b4ad1ad00",
    app: {
        browser: "https://authentrend.com/at-wallet/",
        ios: "https://apps.apple.com/app/at-wallet/id1479171310",
        android: "https://play.google.com/store/apps/details?id=com.authentrend.atwallet",
        mac: "https://apps.apple.com/app/at-wallet/id1490097962",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "atwallet://",
        universal: null,
    },
    desktop: {
        native: "atwallet://",
        universal: "https://apps.apple.com/us/app/at-wallet/id1490097962?mt=12",
    },
};
//# sourceMappingURL=index.js.map